<template>
    <div
        class="page-content w-full min-h-0"
        :class="{ 'has-power-by padding-power-by': hasPoweredBy, 'has-rounded': rounded }"
        :style="styleComputed"
    >
        <slot></slot>
    </div>
</template>

<script>
import PropsHelper from "@/helper/PropsHelper"

export default {
    name: "PageContent",
    props: {
        hasPoweredBy: {
            type: Boolean,
            default: true
        },
        rounded: {
            type: Boolean,
            default: false
        },
        marginTop: {
            type: [Number, String],
            default: 32
        },
        paddingTop: {
            type: [Number, String],
            default: 22
        }
    },
    computed: {
        styleComputed: function () {
            let styles = {}
            if (this.rounded) {
                styles = {
                    marginTop: PropsHelper.getBoxUnit(this.marginTop, false, true),
                    paddingTop: PropsHelper.getBoxUnit(this.paddingTop)
                }
            }
            return styles
        }
    }
}
</script>
